import React from 'react'

const ContactSection = () => {
  return (
    <section className="contact-section">
    <div className="auto-container">
      <div className="sec-title text-center">
        <span className="sub-title">GET IN TOUCH</span>
        <h2>If Contact With Us Send Detail</h2>
        <span className="divider" />
      </div>
      <div className="contact-form">
        <form
          method="post"
          action="https://themecraze.net/html/cpc75/sendemail.php"
          id="contact-form"
        >
          <div className="row clearfix">
            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <div className="input-outer">
                <input
                  type="text"
                  name="username"
                  placeholder="Name"
                  required=""
                />
                <span className="icon fa fa-user" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <div className="input-outer">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  required=""
                />
                <span className="icon fa fa-envelope" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <div className="input-outer">
                <input type="text" name="phone" placeholder="Phone" required="" />
                <span className="icon fa fa-phone" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <div className="input-outer">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  required=""
                />
                <span className="icon fa fa-pencil-alt" />
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 form-group">
              <textarea name="message" placeholder="Message" defaultValue={""} />
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 form-group text-center">
              <button
                className="theme-btn btn-style-one"
                type="submit"
                name="submit-form"
              >
                <span className="btn-title">Submit Now</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
  
  )
}

export default ContactSection